/**
 * @name Enum
 */
import type { ISelectOption } from '../@types/global'

export enum HttpStatusCode {
  Ok = 200,
  MovedPermanently = 301,
  MovedTemporarily = 302,
  SeeOther = 303,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  InternalServerError = 500
}

/**
 * @name String Enum
 */

export const LIST_KEY_ERROR_FROM_BACKEND = {
  REGISTER: 'REGISTER'
}

export const MAX_LINK = 14

export const DEFAULT_PAGE_SIZE = 25
export const DEFAULT_PAGE_2X_SIZE = 50
export const DEFAULT_PAGE_4X_SIZE = 100
export const DEFAULT_MAX_PAGE_SIZE = 2500
export const DEFAULT_MOUNT_PAGE_SIZE = 10
export const DEFAULT_LOADING_PAGE_SIZE = 5
export const DEFAULT_ASYNC_LOADING_OPTIONS = 15
export const MAX_CHARACTERS_INTRODUCTION = 10000
export const MAX_CHARACTERS_CALL_LOGS = 1000
export const MAX_FILES_UPLOAD_AT_ONCE = 5
export const DEFAULT_PAGE_SIZE_COURSE = 6
export const PAGINATION_SIZE = [
  DEFAULT_MOUNT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_2X_SIZE,
  DEFAULT_PAGE_4X_SIZE
]

export const REMOTE_STATUS = {
  NO_REMOTE: 'no_remote',
  HYDRID_REMOTE: 'hybrid_remote',
  FULLY_REMOTE: 'fully_remote'
}

export const REFERRAL = 'referral'
export const REQUISITION = 'requisition'
export const IMPORT_JOB = 'import_job'
export const HIRING_PORTAL = 'hiring_portal'
export const SSO = 'sso'

export const DIRECT_EMPLOYER_TENANT = 'employer'
export const PRIVATE = 'private'
export const PUBLIC = 'public'

export const GLEAP_EVENTS = {
  firstLocationCreated: 'firstLocationCreated',
  firstDepartmentCreated: 'firstDepartmentCreated',
  firstJobCreated: 'firstJobCreated',
  firstCandidateAdded: 'firstCandidateAdded',
  firstMemberInvited: 'firstMemberInvited'
}
export const JOB = 'job'
export const PROFILE = 'profile'
export const CONTACT = 'contact'
export const PLACEMENT = 'placement'
export const COMPANY = 'company'
export const APPLICANT = 'applicant'
export const EMAIL = 'email'
export const PHONE = 'phone'
export const LOCATION = 'location'
export const LINKS = 'links'
export const CONTACT_DETAILS = [JOB, EMAIL, PHONE, LOCATION, LINKS]
export const LOCAL = 'local'
export const CLOUD = 'cloud'
export const RESUME = 'resume'
export const COMPANY_KIND = 'company_kind'
export const PROFILE_TABS = {
  INFORMATION: 'information',
  RESUME: 'resume',
  FILES: 'files',
  IN_ACTIVE: 'item-in-active'
}
export const STAGE_TYPE = {
  sourced: { id: 1, label: 'Sourced' },
  applied: { id: 2, label: 'Applied' },
  screening: { id: 3, label: 'Screening' },
  interview: { id: 4, label: 'Interview' },
  offer: { id: 5, label: 'Offer' },
  hired: { id: 6, label: 'Hired' },
  clientSubmission: { id: 7, label: 'Client submission' }
}
export const UPLOAD = 'upload'
export const PENDING = 'pending'
export const ERROR = 'error'
export const WARNING = 'warning'

export const MAXIMUM_SIZE_FILE_TEXT = '10MB'

export const PERMISSION_MODULE = {
  report: 'report',
  jobManagement: 'job_management',
  companyManagement: 'company_management',
  placement: 'placement'
}
export const TAB_MEMBERS = 'members'
export const TAB_TEAMS = 'teams' // TODO: RENAME TO TAB_DEPARTMENTS
export const TAB_CANDIDATES = 'candidates'
export const TAB_COMPANIES = 'companies'
export const TAB_INTERNAL = 'internal'
export const TAB_EXTERNAL = 'external'
export const KEY_FILTER_TEAM_AND_MEMBER = {
  profitSplitUserIds: 'profitSplitUserIds',
  departmentIds: 'departmentIds',
  ownerIds: 'ownerIds',
  hiringMemberIds: 'hiringMemberIds',
  membersOfDepartmentIds: 'membersOfDepartmentIds'
}
export const LIST_ACTION_FILTERS = {
  updateView: 'UPDATE_VIEW',
  applyFilter: 'APPLY_FILTER',
  clearFilter: 'CLEAR_FILTER',
  saveAsNewView: 'SAVE_AS_NEW_VIEW'
}
export const DESC_SORTING = 'desc'
export const ASC_SORTING = 'asc'

export const DEFAULT_SIZE_COLUMN = 40
export const MAX_SIZE_FREEZE_COLUMN = 680
export const INFINITY_SIZE_COLUMN = 40 * 40 * 40 * 40
export const MAPPING_TABLE_SIZE_COLUMN = {
  system: DEFAULT_SIZE_COLUMN,
  checked: DEFAULT_SIZE_COLUMN,
  id: DEFAULT_SIZE_COLUMN * 4,
  file: DEFAULT_SIZE_COLUMN * 2,
  number: DEFAULT_SIZE_COLUMN * 2,
  quantitativeNumber: DEFAULT_SIZE_COLUMN * 2,
  boolean: DEFAULT_SIZE_COLUMN * 2,
  image: DEFAULT_SIZE_COLUMN * 3,
  icons: DEFAULT_SIZE_COLUMN * 3,
  qualitativeNumber: DEFAULT_SIZE_COLUMN * 4,
  badge: DEFAULT_SIZE_COLUMN * 4,
  date: DEFAULT_SIZE_COLUMN * 4,
  text: DEFAULT_SIZE_COLUMN * 5,
  tags: DEFAULT_SIZE_COLUMN * 5,
  links: DEFAULT_SIZE_COLUMN * 5,
  paragraph: DEFAULT_SIZE_COLUMN * 5
}
export const OPTION_SORT_HEADER_TABLE: ISelectOption[] = [
  {
    value: 'desc',
    label: 'desc',
    icon: 'ArrowDown'
  },
  {
    value: 'asc',
    label: 'asc',
    icon: 'ArrowUp'
  }
]
export const OPTION_SORT_DESC_SORTING = 'desc'
export const OPTION_SORT_ASC_SORTING = 'asc'

export const THUMBNAIL_DEFAULT = '/img/feature/careers/default_course.png'

export enum AppType {
  INTERNAL_APP = 'user',
  CHUB_APP = 'chub_user',
  PUBLIC = 'public'
}

export enum OwnershipActivityType {
  candidate = 'candidate',
  company = 'company'
}

export const FILTER_FIELDS_VALUE = {
  operator: 'operator',
  publicId: 'public_id',
  title: 'title',
  description: 'description',
  referenceId: 'reference_id',
  status: 'status',
  listSavedJobMemberIds: 'list_saved_job_member_ids', // saved status
  countryStateId: 'country_state_id',
  departmentId: 'department_id',
  headcount: 'headcount',
  hiringMemberIds: 'hiring_member_ids',
  jobCategory: 'job_category',
  openedAt: 'opened_at',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
  createdBy: 'created_by',
  employmentType: 'employment_type',
  taggedIds: 'tagged_ids',
  companyId: 'company_id',
  closingDate: 'closing_date',
  tabsMembersTeams: 'tabsMembersTeams',
  jobId: 'job_id',
  applicantStatuses: 'applicant_statuses',
  stageTypeId: 'stage_type_id',
  ownerId: 'owner_id',
  sourced: 'sourced',
  profileTalentPoolIds: 'profile_talent_pool_ids',
  profileLevel: 'profile_level',
  profileCvsEmpty: 'profile_cvs_empty',
  fullName: 'full_name',
  email: 'email',
  phoneNumber: 'phone_number',
  links: 'links',
  summary: 'summary',
  headline: 'headline',
  position: 'position',
  departmentIds: 'department_ids',
  birthday: 'birthday',
  openToWork: 'open_to_work',
  skills: 'skills',
  languages: 'languages',
  willingToRelocate: 'willing_to_relocate',
  noticeToPeriodDays: 'notice_to_period_days',
  totalYearsOfExp: 'total_years_of_exp',
  nationality: 'nationality',
  expectedSalary: 'expected_salary',
  currentSalary: 'current_salary',
  educations: 'educations',
  workExperiences: 'work_experiences',
  preferredWorkStateIds: 'preferred_work_state_ids',
  jobLevel: 'job_level',
  location: 'location',
  clientSubmissionDate: 'client_submission_date',
  hiredDate: 'hired_date',
  offerDate: 'offer_date',
  datetime: 'datetime',
  stageLabel: 'stage_label',
  organizerId: 'organizer_id',
  interviewAttendees: 'interview_attendees'
}

export enum USER_TENANT_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

/** Timeout (ms) cho request export CSV (jobs, candidates, reports). 0 = không giới hạn thời gian. */
export const EXPORT_CSV_REQUEST_TIMEOUT_MS = 0
export const FORM_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view'
}

export const SHOW_TEAMS_TAB = true

export const ACTIVE = 'active'
export const ARCHIVED = 'archived'

export enum ProfileFieldPermissionStatsKey {
  Profile = 'profile',
  Applicant = 'applicant'
}

export enum FieldPermissionModuleName {
  ProfileManagement = 'profile_management',
  JobManagement = 'job_management'
}

export const UDEMY_PROVIDER = 'udemy'
export const INTEGRATION_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected'
}

export const TYPE_OF_SALARY = {
  annual: 'annual',
  monthly: 'monthly'
}
